const date = new Date()

export default function copyright(company) {
  return `© ${company || ''} ${date.getFullYear()}`
}
